import { useState } from 'react';
import { Link } from 'react-router-dom';
import { projects, projectCategories } from '../data/projectsData';
import '../styles/all-projects.css';

const AllProjects = () => {
    const [selectedCategory, setSelectedCategory] = useState('all');
    const [imageError, setImageError] = useState({});

    const filteredProjects = selectedCategory === 'all' 
        ? projects
        : projects.filter(project => project.category === selectedCategory);

    const handleImageError = (projectId) => {
        setImageError(prev => ({
            ...prev,
            [projectId]: true
        }));
    };

    return (
        <div className="all-projects-container">
            <div className="project-header">
                <div className="header-top">
                    <Link to="/" className="back-link">
                        <i className="fas fa-arrow-left"></i>
                        Back to Home
                    </Link>
                    <h1>My Projects</h1>
                </div>
                <div className="project-meta">
                    <p className="header-description">
                        Explore my portfolio of web and mobile applications
                    </p>
                </div>
            </div>

            <div className="category-filter">
                {projectCategories.map(category => (
                    <button
                        key={category.id}
                        onClick={() => setSelectedCategory(category.id)}
                        className={`category-button ${
                            selectedCategory === category.id ? 'active' : ''
                        }`}
                    >
                        {category.label}
                    </button>
                ))}
            </div>

            <div className="projects-grid">
                {filteredProjects.length === 0 ? (
                    <div className="no-projects">
                        <h3>No projects found in this category.</h3>
                    </div>
                ) : (
                    filteredProjects.map(project => (
                        <div key={project.id} className="project-card">
                            <Link to={`/project/${project.id}`} className="project-link-wrapper">
                                <div className="project-content">
                                    <div className="project-image">
                                        <img 
                                            src={imageError[project.id] ? '/images/default-project.jpg' : project.imageUrl}
                                            alt={project.title}
                                            onError={() => handleImageError(project.id)}
                                        />
                                    </div>
                                    <div className="project-info">
                                        <div className="project-tags">
                                            {project.tags.map((tag, index) => (
                                                <span key={index}>{tag}</span>
                                            ))}
                                        </div>
                                        <h3>{project.title}</h3>
                                        <p>{project.description}</p>
                                    </div>
                                </div>
                            </Link>
                        </div>
                    ))
                )}
            </div>
        </div>
    );
};

export default AllProjects;